import { Card, CardText } from 'material-ui/Card';
import r from 'render-dom';
import { Container } from 'react-grid-system';

import fiveOhThree from './503.svg';

const style = {
    paddingTop: 70,
    textAlign: 'center',
};

const FiveOhThree = () => {
    return (
        r(Container, { style }, [
            r(Card, [
                r(CardText, [
                    r.img({ role: 'presentation', src: fiveOhThree }),
                    r.h2([
                        'We\'re busy building something awesome!',
                    ]),
                    r.h4([
                        'Refresh your page or come back later.',
                    ]),
                ]),
            ]),
        ])
    );
};

export default FiveOhThree;



// WEBPACK FOOTER //
// ./src/components/public/FiveOhThree/index.js